var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"nav-btn",attrs:{"dark":"","outlined":!_vm.active,"color":_vm.active ? _vm.activeColor : _vm.normalColor,"to":_vm.to,"icon":_vm.icon,"exact":"","large":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }